export { createApolloClient } from './create-apollo-client';
